import { Auth } from 'aws-amplify';

export const checkPremiumStatus = async () => {
  try {
    // Get current authenticated user
    const user = await Auth.currentAuthenticatedUser();
    const session = await Auth.currentSession();
    const jwt = session.getIdToken().getJwtToken();
    const username = user.username.includes("Google_")
      ? user.attributes.email
      : user.username;

    // Check subscription status with timeout
    const res = await fetch("https://api.dev.quizwizard.net/quiz/getSubscription", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": jwt,
      },
      body: JSON.stringify({ username }),
    });

    const data = await res.json();

    // Check both subscription status and premium user flag
    const isPremium = data.status === "active" || user.attributes['custom:premiumuser'] === '1';

    return {
      isPremium,
      user,
      attributes: user.attributes || {},
      idToken: user.signInUserSession?.idToken?.payload,
      subscriptionStatus: isPremium ? 'active' : 'inactive',
      isLoading: false,
      error: null
    };

  } catch (error) {
    console.error('Error checking premium status:', error);
    return {
      isPremium: false,
      error,
      message: 'Error checking premium status'
    };
  }
};
